import { useCallback, useEffect, useState } from "react";
import {
  getVerificationSatusActions,
  IVerificationStatusAction,
} from "../network";
import { VerificationStatus } from "../utils/getStatus";

export type IModalButtons = {
  [key in VerificationStatus]: IVerificationStatusAction;
};

export type TVerificationStatusActionsResult = {
  actions: IVerificationStatusAction[];
  buttons: IVerificationStatusAction[];
  modalButtons: IModalButtons;
};

export const useVerificationStatusActions = (
  requestId: string
): [TVerificationStatusActionsResult, boolean, Error | null, () => void] => {
  const [result, setResult] = useState<TVerificationStatusActionsResult>({
    actions: [],
    buttons: [],
    modalButtons: {} as IModalButtons,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await getVerificationSatusActions(requestId);
      const buttons = [];
      const actions = [];
      const modalButtons = {} as IModalButtons;
      for (let item of response) {
        modalButtons[item.to] = item;
        if (
          [
            VerificationStatus.ACCEPTED,
            VerificationStatus.CANCELED,
            VerificationStatus.REJECTED,
            VerificationStatus.ON_FINAL_REVIEW,
          ].includes(item.to)
        ) {
          buttons.push(item);
        } else {
          actions.push(item);
        }
      }

      setResult({ buttons, actions, modalButtons });
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error("Unknown error"));
      }
    }
    setIsLoading(false);
  }, [requestId]);

  useEffect(() => {
    request();
  }, [request]);

  return [result, isLoading, error, request];
};
